import {CustomerRepository} from "../CustomerRepository.js";
import {Customer} from "../Customer.js";

export class ClickUpCustomerRepository extends CustomerRepository {

    /**
     * @private {ClickUpClient}
     */
    _client;

    _customerListID = ""

    /**
     * @type {Customer[]}
     * @private
     */
    _customerCache = [];

    constructor(client, customerListID) {
        super();
        this._client = client;
        this._customerListID = customerListID;
    }

    async all() {

        if (this._customerCache.length) {
            return this._customerCache;
        }

        let tasks = await this._client.getTasks(this._customerListID);

        /** @type {Customer[]} **/
        let customers = [];

        for (let task of tasks) {
            customers.push(this._toCustomer(task));
        }

        customers.sort( (a,b) => {
            return parseInt(a.id) - parseInt(b.id);
        });

        this._customerCache = customers;

        return customers;
    }

    /**
     * @param {Task} task
     * @return Customer
     */
    _toCustomer(task) {
        let customer = new Customer()
        customer.name = task.name;
        customer.url = task.url;
        if (task.customMap.hasOwnProperty('Customer Number')) {
            customer.id = task.customMap["Customer Number"];
        }
        if (task.customMap.hasOwnProperty('ClickUp Workspace ID')) {
            customer.workspaceId = task.customMap["ClickUp Workspace ID"];
        }
        if (task.customMap.hasOwnProperty('Folder Name')) {
            customer.folderName = task.customMap["Folder Name"];
        }
        if (task.customMap.hasOwnProperty('Hourly Rate') && task.customMap["Hourly Rate"]) {
            customer.hourlyRate = parseFloat(task.customMap["Hourly Rate"]);
        }
        if (task.customMap.hasOwnProperty('Hours Per Week') && task.customMap["Hours Per Week"]) {
            customer.hoursPerWeek = parseInt(task.customMap["Hours Per Week"]);
        }
        if (task.customMap.hasOwnProperty('Last Invoice At') && task.customMap["Last Invoice At"]) {
            let lastInvoiceAt = parseInt(task.customMap["Last Invoice At"]);
            customer.lastInvoiceAt = new Date(lastInvoiceAt);
        }
        return customer;
    }
}